import React, { useState } from 'react';
import { Icon } from '@iconify/react';

function AccountInfo() {
  const [selectedColor, setSelectedColor] = useState('#3152e8'); // Default primary color
  const [appearance, setAppearance] = useState('light'); // Default appearance
  
  const colorOptions = [
    { value: '#ffffff', name: 'White', class: 'color-white' },
    { value: '#e8d0b0', name: 'Beige', class: 'color-beige' },
    { value: '#ffd4e5', name: 'Pink', class: 'color-pink' },
    { value: '#f8d0b0', name: 'Peach', class: 'color-peach' },
    { value: '#e8b0d5', name: 'Lavender Pink', class: 'color-lavender-pink' },
    { value: '#90c4f8', name: 'Sky Blue', class: 'color-sky-blue' },
    { value: '#b0e8e0', name: 'Mint', class: 'color-mint' },
    { value: '#d0b0e8', name: 'Light Purple', class: 'color-light-purple' },
    { value: '#c0d0c0', name: 'Light Green', class: 'color-light-green' },
  ];

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    // Here you would typically save this preference to your backend or localStorage
    document.documentElement.style.setProperty('--primary-color', color);
  };

  const handleAppearanceChange = (mode) => {
    setAppearance(mode);
    // Here you would typically save this preference and apply the theme
  };

  return (
    <div className="p-4">
      <div className="mb-6">
        <h3 className="text-2xl font-semibold mb-2">Account Information</h3>
        <p className="text-gray-500">Manage your personal information and account details</p>
      </div>
      
      {/* Primary Color Settings */}
      <div className="mb-6">
        <h4 className="text-lg font-semibold mb-4">Primary color settings</h4>
        <div className="flex flex-wrap gap-3">
          {colorOptions.map((color) => (
            <div 
              key={color.value} 
              className={`w-12 h-12 rounded-full cursor-pointer flex items-center justify-center ${selectedColor === color.value ? 'ring-2 ring-primary ring-offset-2' : ''}`}
              style={{ backgroundColor: color.value }}
              onClick={() => handleColorSelect(color.value)}
              title={color.name}
            >
              {selectedColor === color.value && (
                <Icon icon="mdi:check" className="text-white" width="24" height="24" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Appearance Settings */}
      <div className="mb-6">
        <h4 className="text-lg font-semibold mb-4">Appearance</h4>
        <div className="flex gap-4">
          <div 
            className={`cursor-pointer p-4 border-2 rounded-lg ${appearance === 'dark' ? 'border-primary' : 'border-gray-200'}`}
            onClick={() => handleAppearanceChange('dark')}
          >
            <div className="w-32 h-20 bg-gray-800 rounded mb-2 relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-4 bg-gray-700"></div>
              <div className="absolute left-0 top-4 bottom-0 w-8 bg-gray-900"></div>
              <div className="absolute left-8 top-4 right-0 bottom-0 p-2 space-y-1">
                <div className="h-2 bg-gray-700 rounded"></div>
                <div className="h-2 bg-gray-700 rounded"></div>
              </div>
            </div>
            <div className="text-sm font-medium text-center">Dark</div>
          </div>

          <div 
            className={`cursor-pointer p-4 border-2 rounded-lg ${appearance === 'light' ? 'border-primary' : 'border-gray-200'}`}
            onClick={() => handleAppearanceChange('light')}
          >
            <div className="w-32 h-20 bg-white border border-gray-200 rounded mb-2 relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-4 bg-gray-100"></div>
              <div className="absolute left-0 top-4 bottom-0 w-8 bg-gray-50 border-r border-gray-200"></div>
              <div className="absolute left-8 top-4 right-0 bottom-0 p-2 space-y-1">
                <div className="h-2 bg-gray-100 rounded"></div>
                <div className="h-2 bg-gray-100 rounded"></div>
              </div>
            </div>
            <div className="text-sm font-medium text-center">Light</div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default AccountInfo;